/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Gray_Ox_BlowInputs */

const en_glad_gray_ox_blow = /** @type {(inputs: Glad_Gray_Ox_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss all`)
};

const de_glad_gray_ox_blow = /** @type {(inputs: Glad_Gray_Ox_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ablehnen`)
};

/**
* | output |
* | --- |
* | "Dismiss all" |
*
* @param {Glad_Gray_Ox_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_gray_ox_blow = /** @type {((inputs?: Glad_Gray_Ox_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Gray_Ox_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_gray_ox_blow(inputs)
	return de_glad_gray_ox_blow(inputs)
});